import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CallsPage } from './calls';
import { UserHeaderComponentModule } from '../../components/header/header.module';
import { MomentModule } from 'ngx-moment';

@NgModule({
  declarations: [
    CallsPage,
  ],
  imports: [
    IonicPageModule.forChild(CallsPage),
    UserHeaderComponentModule,
    MomentModule
  ],
})
export class CallsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/calls/calls.module.ts